export default __webpack_public_path__ + "static/media/ps.ee9c7fec.jpg";